export const transformResultsFromObjectSplitByVendor = (result, vendor) => {
    const _transformResultsFromObjectSplitByVendor = () => Object.keys(result).map(key => ({
        ...result[key],
        id: key,
        vendor
    }));

    return result instanceof Array ? result : _transformResultsFromObjectSplitByVendor();
};


export const transformResultsFromObject = result => {
    const _transformResultsFromObject = () => {
        const ret = [];

        for (const key in result) {
            ret.push({
                ...result[key],
                id: key
            });
        }

        return ret;
    };

    return result instanceof Array ? result : _transformResultsFromObject();
};



// WEBPACK FOOTER //
// ./src/util/data.js